module.exports = __webpack_public_path__ + "elephant-friend-df0b9c6af525e0dea9f1f9c044d9a903.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant-friend.png
// module id = 188
// module chunks = 65